import React, { useRef, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from "prop-types";

export default function EmailPreview({documentJson, chamaileonPlugins, callback}) {
    const initialized = useRef(false);

    const initializeSDK = async () => {
        initialized.current = true;
        const instance = await chamaileonPlugins.createFullscreenPlugin({
            plugin: 'preview',
            data: { document: documentJson },
            hooks: {
                close: () => {
                    instance.destroy();
                    callback();
                }
            },
            settings: {}
        });
        instance.show();
    }

    useEffect(()=>{
        if(!initialized.current){
            initializeSDK();
        }
    }, []);

    return (
        <Container className="mt-4"></Container>
    );
};

EmailPreview.propTypes = {
    documentJson: PropTypes.object,
    chamaileonPlugins: PropTypes.object,
    callback: PropTypes.func,
}